module.exports = __webpack_public_path__ + "static/img/9.bf7e0e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/9.jpg
// module id = WuL6
// module chunks = 1